
import React, { lazy } from 'react';
import { Redirect } from 'react-router-dom';

import AuthGuard from './components/AuthGuard';

import AuthLayout from './layouts/Auth';
import ErrorLayout from './layouts/Error';
import DashboardLayout from './layouts/Dashboard';
import DashboardAnalyticsView from './views/DashboardAnalytics';
import DashboardDefaultView from './views/DashboardDefault';
import OverviewView from './views/Overview';
import Home from './views/Home';
import PresentationView from './views/Presentation';
import Users from './views/Management/components/Users';
import Operators from './views/Management/components/Operators';
import OperatorDetails from './views/Management/components/OperatorDetails';
import Settings from './views/Management/components/Settings';
import DashboardInspect from './views/Dashboard/components/Inspect/DashboardInspect.js';
import StepIn from './views/StepInFollowUp/StepIn.js';
import DataManagement from './views/DataManagement/DataManagement.js';
import Outliers from './views/Shutdown3g/components/Shutdown3g.js';
import ActivitiesTracker from './views/ActivityTracker/components/TrackerPage.jsx';
import ActivitiesMap from './views/ActivityMap/App.jsx';
import ActivityKPIDashboard from './views/ActivityPerformance/main.jsx';
import AnalyticsDashboard from './views/AnalyticsDashboard/index.jsx';
import TrackableRoute from './views/AnalyticsDashboard/TrackableRoute.js';
import Beacon4Blended from './views/Beacon4Blended/main.jsx';
import Beacon4Synthesis from './views/Beacon4Synthesis/main.jsx';
import RadioDesignUserPrivileges from './views/RadioDesignUserPrivileges/index.jsx';
import LockdownKPIDashboard from './views/LockdownKPIDashboard/main.jsx';
import LockdownManagement from './views/LockdownManagement/LockdownAggregation';

const routes = [
	{
		path: '/',
		exact: true,
		component: () => <Redirect to="/home" />,
	},
	{
		path: '/home',
		exact: true,
		component: () => AuthGuard({
			children: DashboardLayout(
				{
					route: {
						routes: [
							{
								path: '*',
								exact: true,
								component: (props) => AuthGuard({
									children: Home(props)
								}),
							},
							{
								component: () => <Redirect to="/errors/error-404" />,
							},
						],
					}

				}),
		}),
	},
	{
		path: '/DataManagement',
		exact: true,
		component: () => AuthGuard({
			roles: ['Administrator', 'Manager', 'CelfinetHQ', 'CelfinetOS'],
			projects: ['VMO2 Ran', 'VMO2 Radio Design'],
			children: DashboardLayout(
				{
					route: {
						routes: [
							{
								exact: true,
								component: () => AuthGuard({
									children: TrackableRoute({
										moduleId: 'DataManagement',
										moduleName: 'Data Management',
										children: DataManagement()
									}),
								}),
							},
							{
								component: () => <Redirect to="/errors/error-404" />,
							},
						],
					}
				}
			)
		}),
	},
	{
		path: '/NetworkFaultsDetector',
		component: () => AuthGuard({
			children: DashboardLayout(
				{
					route: {
						routes: [
							{
								path: '/NetworkFaultsDetector/5G',
								exact: true,
								component: () => AuthGuard({
									roles: ['Administrator', 'Manager', 'CelfinetHQ', 'CelfinetOS', 'Client'],
									projects: ['VMO2 Dashboards', 'VMO2 Ran'],
									children: TrackableRoute({
										moduleId: 'NetworkFaultsDetector5G',
										moduleName: 'NetworkFaults Detector 5G',
										children: DashboardInspect({ match: { params: { id: 21 } }, pageTitle: 'NetworkFaultsDetector5G', module: 'Network Faults Detector 5G' })
									}),
								}),
							},
							{
								path: '/NetworkFaultsDetector/4G',
								exact: true,
								component: () => AuthGuard({
									roles: ['Administrator', 'Manager', 'CelfinetHQ', 'CelfinetOS'],
									projects: ['VMO2 Dashboards', 'VMO2 Ran'],
									children: TrackableRoute({
										moduleId: 'NetworkFaultsDetector4G',
										moduleName: 'NetworkFaults Detector 4G',
										children: DashboardInspect({ match: { params: { id: 25 } }, pageTitle: 'NetworkFaultsDetector4G', module: 'Network Faults Detector 4G' })
									}),
								}),
							},
							{
								component: () => <Redirect to="/errors/error-404" />,
							},
						],
					}
				}
			)
		}),
	},
	{
		path: '/Cluster',
		component: () => AuthGuard({
			children: DashboardLayout(
				{
					route: {
						routes: [
							{
								path: '/Cluster/Management',
								exact: true,
								component: () => AuthGuard({
									roles: ['Administrator', 'Manager', 'CelfinetHQ', 'CelfinetOS', 'Client'],
									projects: ['VMO2 Dashboards', 'VMO2 Ran'],
									children: TrackableRoute({
										moduleId: 'LockdownManagement',
										moduleName: 'Lockdown Management',
										children: LockdownManagement()
									}),
								}),
							},
							{
								path: '/Cluster/LockdownKPI',
								exact: true,
								component: () => AuthGuard({
									roles: ['Administrator'/* , 'Manager', 'CelfinetHQ', 'CelfinetOS', 'Client' */],
									projects: ['VMO2 Dashboards', 'VMO2 Ran'],
									children: TrackableRoute({
										moduleId: 'LockdownKPI',
										moduleName: 'Lockdown KPI',
										children: LockdownKPIDashboard()
									}),
								}),
							},
							{
								path: '/Cluster/DemandKPIsView',
								exact: true,
								component: () => AuthGuard({
									roles: ['Administrator', 'Manager', 'CelfinetHQ', 'CelfinetOS', 'Client'],
									projects: ['VMO2 Dashboards', 'VMO2 Ran'],
									children: TrackableRoute({
										moduleId: 'Demand KPIs View',
										moduleName: 'Demand KPIs View',
										children: DashboardInspect({ match: { params: { id: 27 } }, pageTitle: 'DemandKPIsView', module: 'Demand KPIs View' })
									}),
								}),
							},
							{
								component: () => <Redirect to="/errors/error-404" />,
							},
						],
					}
				}
			)
		}),
	},
	{
		path: '/StepIn',
		component: () => AuthGuard({
			children: DashboardLayout(
				{
					route: {
						routes: [
							{
								path: '/StepIn/Management',
								exact: true,
								component: () => AuthGuard({
									roles: ['Administrator', 'Manager', 'CelfinetHQ', 'CelfinetOS'],
									projects: ['VMO2 Dashboards', 'VMO2 Ran'],
									children: TrackableRoute({
										moduleId: 'StepIn',
										moduleName: 'Step In',
										children: StepIn()
									}),
								}),
							},
							{
								path: '/StepIn/Timeline',
								exact: true,
								component: () => AuthGuard({
									roles: ['Administrator', 'Manager', 'CelfinetHQ', 'CelfinetOS', 'Client'],
									projects: ['VMO2 Dashboards', 'VMO2 Ran'],
									children: TrackableRoute({
										moduleId: 'StepInTimeline',
										moduleName: 'Step In Timeline',
										children: DashboardInspect({ match: { params: { id: 26 } }, pageTitle: 'Step In', module: 'Timeline' })
									}),
								}),
							},
							{
								component: () => <Redirect to="/errors/error-404" />,
							},
						],
					}
				}
			)
		}),
	},
	{
		path: '/Performance',
		exact: true,
		component: () => AuthGuard({
			roles: ['Administrator', 'Manager', 'CelfinetHQ', 'CelfinetOS', 'Client'],
			projects: ['VMO2 Dashboards', 'VMO2 Ran'],
			children: DashboardLayout(
				{
					route: {
						routes: [
							{
								path: '*',
								exact: true,
								component: () => AuthGuard({
									children: TrackableRoute({
										moduleId: 'Performance',
										moduleName: 'Performance',
										children: DashboardInspect({ match: { params: { id: 19 } }, pageTitle: 'Performance', module: 'Performance' })
									}),
								}),
							},
							{
								component: () => <Redirect to="/errors/error-404" />,
							},
						],
					}
				}
			)
		}),
	},
	{
		path: '/Blended',
		component: () => AuthGuard({
			children: DashboardLayout(
				{
					route: {
						routes: [
							{
								path: '/Blended/MonthlyBlended1',
								exact: true,
								component: () => AuthGuard({
									roles: ['Administrator', 'Manager', 'CelfinetHQ', 'CelfinetOS', 'Client'],
									projects: ['VMO2 Dashboards', 'VMO2 Ran'],
									children: TrackableRoute({
										moduleId: 'Monthly BlendedPack1',
										moduleName: 'Monthly Blended (Pack 1)',
										children: DashboardInspect({ match: { params: { id: 22 } }, pageTitle: 'Monthly Blended', module: 'Blended (Pack 1)' })
									}),

								}),
							},
							{
								path: '/Blended/MonthlyBlended2',
								exact: true,
								component: () => AuthGuard({
									roles: ['Administrator', 'Manager', 'CelfinetHQ', 'CelfinetOS', 'Client'],
									projects: ['VMO2 Dashboards', 'VMO2 Ran'],
									children: TrackableRoute({
										moduleId: 'Monthly BlendedPack2',
										moduleName: 'Monthly Blended (Pack 2)',
										children: DashboardInspect({ match: { params: { id: 24 } }, pageTitle: 'Monthly Blended', module: 'Blended (Pack 2)' })
									}),
								}),
							},
							{
								path: '/Blended/WeeklyBlended',
								exact: true,
								component: () => AuthGuard({
									roles: ['Administrator', 'Manager', 'CelfinetHQ', 'CelfinetOS', 'Client'],
									projects: ['VMO2 Dashboards', 'VMO2 Ran'],
									children: TrackableRoute({
										moduleId: 'Weekly Blended',
										moduleName: 'Weekly Blended',
										children: DashboardInspect({ match: { params: { id: 23 } }, pageTitle: 'Weekly Blended', module: 'Blended' })
									}),
								}),
							},
							{
								path: '/Blended/Performance',
								exact: true,
								component: () => AuthGuard({
									roles: ['Administrator', 'Manager', 'CelfinetHQ', 'CelfinetOS'],
									projects: ['VMO2 Ran'],
									children: TrackableRoute({
										moduleId: 'PerformanceBlended',
										moduleName: 'Performance Blended',
										children: Beacon4Blended()
									}),
								}),
							},
							{
								path: '/Blended/Synthesis',
								exact: true,
								component: () => AuthGuard({
									roles: ['Administrator', 'Manager', 'CelfinetHQ', 'CelfinetOS'],
									projects: ['VMO2 Ran'],
									children: TrackableRoute({
										moduleId: 'Synthesis',
										moduleName: 'Synthesis',
										children: Beacon4Synthesis()
									}),
								}),
							},
							{
								component: () => <Redirect to="/errors/error-404" />,
							},
						],
					}
				}
			)
		}),
	},
	{
		path: '/Shutdown3g',
		component: () => AuthGuard({
			children: DashboardLayout(
				{
					route: {
						routes: [
							{
								path: '/Shutdown3g/ClusterKpi/Hourly',
								exact: true,
								component: () => AuthGuard({
									roles: ['Administrator', 'Manager', 'CelfinetHQ', 'CelfinetOS', 'Client'],
									projects: ['3GSD'],
									children: TrackableRoute({
										moduleId: '3GSDClusterKPIHourly',
										moduleName: '3GSD Cluster KPI Hourly',
										children: DashboardInspect({ match: { params: { id: 28 } }, pageTitle: '3GSD', module: 'Cluster KPI Hourly' })
									}),
								}),
							},
							{
								path: '/Shutdown3g/ClusterKpi/Daily',
								exact: true,
								component: () => AuthGuard({
									roles: ['Administrator', 'Manager', 'CelfinetHQ', 'CelfinetOS', 'Client'],
									projects: ['3GSD'],
									children: TrackableRoute({
										moduleId: '3GSDClusterKPIDaily',
										moduleName: '3GSD Cluster KPI Daily',
										children: DashboardInspect({ match: { params: { id: 31 } }, pageTitle: '3GSD', module: 'Cluster KPI Daily' })
									}),
								}),
							},
							{
								path: '/Shutdown3g/CellKpi/Hourly/2G',
								exact: true,
								component: () => AuthGuard({
									roles: ['Administrator', 'Manager', 'CelfinetHQ', 'CelfinetOS'],
									projects: ['3GSD'],
									children: TrackableRoute({
										moduleId: '3GSDCellKPIHourly2G',
										moduleName: '3GSD Cell KPI Hourly 2G',
										children: DashboardInspect({ match: { params: { id: 34 } }, pageTitle: '3GSD', module: 'Cell KPI Hourly - 2G' })
									}),

								}),
							},
							{
								path: '/Shutdown3g/CellKpi/Hourly/3G',
								exact: true,
								component: () => AuthGuard({
									roles: ['Administrator', 'Manager', 'CelfinetHQ', 'CelfinetOS'],
									projects: ['3GSD'],
									children: TrackableRoute({
										moduleId: '3GSDCellKPIHourly3G',
										moduleName: '3GSD Cell KPI Hourly 3G',
										children: DashboardInspect({ match: { params: { id: 38 } }, pageTitle: '3GSD', module: 'Cell KPI Hourly - 3G' })
									}),
								}),
							},
							{
								path: '/Shutdown3g/CellKpi/Hourly/4G',
								exact: true,
								component: () => AuthGuard({
									roles: ['Administrator', 'Manager', 'CelfinetHQ', 'CelfinetOS'],
									projects: ['3GSD'],
									children: TrackableRoute({
										moduleId: '3GSDCellKPIHourly4G',
										moduleName: '3GSD Cell KPI Hourly 4G',
										children: DashboardInspect({ match: { params: { id: 39 } }, pageTitle: '3GSD', module: 'Cell KPI Hourly - 4G' })
									}),
								}),
							},
							{
								path: '/Shutdown3g/CellKpi/Daily/2G',
								exact: true,
								component: () => AuthGuard({
									roles: ['Administrator', 'Manager', 'CelfinetHQ', 'CelfinetOS'],
									projects: ['3GSD'],
									children: TrackableRoute({
										moduleId: '3GSDCellKPIDaily2G',
										moduleName: '3GSD Cell KPI Daily 2G',
										children: DashboardInspect({ match: { params: { id: 35 } }, pageTitle: '3GSD', module: 'Cell KPI Daily - 2G' })
									}),
								}),
							},
							{
								path: '/Shutdown3g/CellKpi/Daily/3G',
								exact: true,
								component: () => AuthGuard({
									roles: ['Administrator', 'Manager', 'CelfinetHQ', 'CelfinetOS'],
									projects: ['3GSD'],
									children: TrackableRoute({
										moduleId: '3GSDCellKPIDaily3G',
										moduleName: '3GSD Cell KPI Daily 3G',
										children: DashboardInspect({ match: { params: { id: 40 } }, pageTitle: '3GSD', module: 'Cell KPI Daily - 3G' })
									}),
								}),
							},
							{
								path: '/Shutdown3g/CellKpi/Daily/4G',
								exact: true,
								component: () => AuthGuard({
									roles: ['Administrator', 'Manager', 'CelfinetHQ', 'CelfinetOS'],
									projects: ['3GSD'],
									children: TrackableRoute({
										moduleId: '3GSDCellKPIDaily4G',
										moduleName: '3GSD Cell KPI Daily 4G',
										children: DashboardInspect({ match: { params: { id: 41 } }, pageTitle: '3GSD', module: 'Cell KPI Daily - 4G' })
									}),
								}),
							},
							{
								path: '/Shutdown3g/Outliers',
								exact: true,
								component: () => AuthGuard({
									roles: ['Administrator', 'Manager', 'CelfinetHQ', 'CelfinetOS', 'Client'],
									projects: ['3GSD'],
									children: TrackableRoute({
										moduleId: '3GSDOutliers',
										moduleName: '3GSD Outliers',
										children: Outliers()
									}),
								}),
							},
							{
								path: '/Shutdown3g/DataIntegrity',
								exact: true,
								component: () => AuthGuard({
									roles: ['Administrator', 'Manager', 'CelfinetHQ'],
									projects: ['3GSD'],
									children: TrackableRoute({
										moduleId: '3GSDDataIntegrity',
										moduleName: '3GSD Data Integrity',
										children: DashboardInspect({ match: { params: { id: 42 } }, pageTitle: '3GSD', module: 'Data Integrity' })
									}),
								}),
							},
							{
								component: () => <Redirect to="/errors/error-404" />,
							},
						],
					}
				}
			)
		}),
	},
	{
		path: '/RadioDesign',
		component: () => AuthGuard({
			children: DashboardLayout(
				{
					route: {
						routes: [
							{
								path: '/RadioDesign/TrafficTrends',
								exact: true,
								component: () => AuthGuard({
									roles: ['Administrator', 'Manager', 'CelfinetHQ', 'CelfinetOS', 'Client'],
									projects: ['VMO2 Radio Design'],
									children: TrackableRoute({
										moduleId: 'TrafficTrends',
										moduleName: 'Traffic Trends',
										children: DashboardInspect({ match: { params: { id: 43 } }, pageTitle: 'Radio Design', module: 'Traffic Trends' })
									}),
								}),
							},
							{
								path: '/RadioDesign/ActivitiesTracker',
								exact: true,
								component: () => AuthGuard({
									roles: ['Administrator', 'Manager', 'CelfinetHQ', 'CelfinetOS', 'Client'],
									projects: ['VMO2 Radio Design'],
									children: TrackableRoute({
										moduleId: 'ActivitiesTracker',
										moduleName: 'Activities Tracker',
										children: ActivitiesTracker()
									}),
								}),
							},
							{
								path: '/RadioDesign/ActivitiesMap',
								exact: true,
								component: () => AuthGuard({
									roles: ['Administrator', 'Manager', 'CelfinetHQ', 'CelfinetOS', 'Client'],
									projects: ['VMO2 Radio Design'],
									children: TrackableRoute({
										moduleId: 'ActivitiesMap',
										moduleName: 'Activities Map',
										children: ActivitiesMap()
									}),
								}),
							}
							,
							{
								path: '/RadioDesign/ActivityPerformance',
								exact: true,
								component: () => AuthGuard({
									roles: ['Administrator', 'Manager', 'CelfinetHQ', 'CelfinetOS', 'Client'],
									projects: ['VMO2 Radio Design'],
									children: TrackableRoute({
										moduleId: 'ActivityPerformance',
										moduleName: 'Activity Performance',
										children: ActivityKPIDashboard()
									}),
								}),
							},
							{
								path: '/RadioDesign/UserPrivileges',
								exact: true,
								component: () => AuthGuard({
									roles: ['Administrator', 'Manager'],
									projects: ['VMO2 Radio Design'],
									children: TrackableRoute({
										moduleId: 'User Privileges',
										moduleName: 'User Privileges',
										children: RadioDesignUserPrivileges()
									}),
								}),
							},
							{
								component: () => <Redirect to="/errors/error-404" />,
							},
						],
					}
				}
			)
		}),
	},
	{
		path: '/EstimateCustomerExperience',
		exact: true,
		component: () => AuthGuard({
			roles: ['Administrator', 'Manager', 'CelfinetHQ', 'CelfinetOS', 'Client'],
			projects: ['VMO2 Dashboards', 'VMO2 Ran'],
			children: DashboardLayout(
				{
					route: {
						routes: [
							{
								path: '*',
								exact: true,
								component: () => AuthGuard({
									children: TrackableRoute({
										moduleId: 'EstimateCustomerExperience',
										moduleName: 'Estimate Customer Experience',
										children: DashboardInspect({ match: { params: { id: 18 } }, pageTitle: 'EstimateCustomerExperience', module: 'Estimate Customer Experience' })
									}),
								}),
							},
							{
								component: () => <Redirect to="/errors/error-404" />,
							},
						],
					}
				}
			)
		}),
	},
	{
		path: '/DemandKPIsView',
		exact: true,
		component: () => AuthGuard({
			roles: ['Administrator', 'Manager', 'CelfinetHQ', 'CelfinetOS', 'Client'],
			projects: ['VMO2 Dashboards', 'VMO2 Ran'],
			children: DashboardLayout(
				{
					route: {
						routes: [
							{
								path: '*',
								exact: true,
								component: () => AuthGuard({
									children: TrackableRoute({
										moduleId: 'DemandKPIsView',
										moduleName: 'Demand KPIs View',
										children: DashboardInspect({ match: { params: { id: 16 } }, pageTitle: 'DemandKPIsView', module: 'Demand KPIs View' })
									}),
								}),
							},
							{
								component: () => <Redirect to="/errors/error-404" />,
							},
						],
					}
				}
			)
		}),
	},
	{
		path: '/naspAvailability',
		exact: true,
		component: () => AuthGuard({
			roles: ['Administrator', 'Manager', 'CelfinetHQ'],
			projects: ['NASP'],
			children: DashboardLayout(
				{
					route: {
						routes: [
							{
								path: '*',
								exact: true,
								component: () => AuthGuard({
									children: TrackableRoute({
										moduleId: 'NASP Availiability',
										moduleName: 'NASP Availiability',
										children: DashboardInspect({ match: { params: { id: 44 } }, pageTitle: 'NASP Availiability', module: 'NASP Availiability' })
									}),
								}),
							},
							{
								component: () => <Redirect to="/errors/error-404" />,
							},
						],
					}
				}
			)
		}),
	},
	{
		path: '/management',
		component: () => AuthGuard({
			children: DashboardLayout(
				{
					route: {
						routes: [
							{
								path: '/management/statistics',
								exact: true,
								component: () => AuthGuard({
									roles: ['Administrator', 'Manager'],
									children: DashboardInspect({ match: { params: { id: 15 } }, pageTitle: 'Statistics', module: 'Management' })
								}),
							},
							{
								path: '/management/AnalyticsDashboard',
								exact: true,
								component: () => AuthGuard({
									roles: ['Administrator', 'Manager'],
									children: AnalyticsDashboard()
								}),
							},
							{
								path: '/management/dataIntegrity',
								exact: true,
								component: () => AuthGuard({
									roles: ['Administrator', 'Manager'],
									children: TrackableRoute({
										moduleId: 'Data Integrity',
										moduleName: 'Data Integrity',
										children: DashboardInspect({ match: { params: { id: 20 } }, pageTitle: 'Data Integrity', module: 'Management' })
									}),
								}),
							},
							{
								path: '/management/operators',
								exact: true,
								component: () => AuthGuard({
									roles: ['Administrator', 'Manager'],
									children: Operators()
								}),
							},
							{
								path: '/management/operators/details',
								exact: true,
								component: () => AuthGuard({
									roles: ['Administrator', 'Manager'],
									children: OperatorDetails()
								}),
							},
							{
								path: '/management/users',
								exact: true,
								component: () => AuthGuard({
									roles: ['Administrator', 'Manager'],
									children: Users(),
								}),
							},
							{
								path: '/management/settings',
								exact: true,
								component: () => AuthGuard({
									children: Settings()
								}),
							},
							{
								component: () => <Redirect to="/errors/error-404" />,
							},
						],
					}

				}
			)
		}),

	},
	{
		path: '/auth',
		component: AuthLayout,
		routes: [
			{
				path: '/auth/login',
				exact: true,
				component: lazy(() => import('views/Auth/Login')),
			},
			{
				path: '/auth/completeregistration',
				exact: true,
				component: lazy(() => import('views/Auth/CompleteRegistration')),
			},
			{
				path: '/auth/resetpassword',
				exact: true,
				component: lazy(() => import('views/Auth/ResetPassword')),
			},
			{
				path: '/auth/requestAccess',
				exact: true,
				component: lazy(() => import('views/Auth/RequestAccess')),
			},
			{
				path: '/auth/requestAccessConfirmation',
				exact: true,
				component: lazy(() => import('views/Auth/RequestAccessConfirmation')),
			},
			{
				path: '/auth/recover',
				exact: true,
				component: lazy(() => import('views/Auth/Recover')),
			},
			{
				path: '/auth/recoverconfirmation',
				exact: true,
				component: lazy(() => import('views/Auth/RecoverConfirmation')),
			},
			{
				component: () => <Redirect to="/errors/error-404" />,
			},
		],
	},
	{
		path: '/errors',
		component: ErrorLayout,
		routes: [
			{
				path: '/errors/error-401',
				exact: true,
				component: lazy(() => import('views/Error401')),
			},
			{
				path: '/errors/error-404',
				exact: true,
				component: lazy(() => import('views/Error404')),
			},
			{
				path: '/errors/error-500',
				exact: true,
				component: lazy(() => import('views/Error500')),
			},
			{
				component: () => <Redirect to="/errors/error-404" />,
			},
		],
	},
	{
		path: '*',
		component: () => AuthGuard({
			roles: ['Administrator'],
			// operator: ['Vodafone', ...]
			children: DashboardLayout({
				route: {
					routes: [
						{
							path: '/notifications',
							exact: true,
							component: lazy(() => import('views/Notifications')),
						},
						{
							path: '/calendar',
							exact: true,
							component: lazy(() => import('views/Calendar')),
						},
						{
							path: '/changelog',
							exact: true,
							component: lazy(() => import('views/Changelog')),
						},
						{
							path: '/chat',
							exact: true,
							component: lazy(() => import('views/Chat')),
						},
						{
							path: '/chat/:id',
							exact: true,
							component: lazy(() => import('views/Chat')),
						},
						{
							path: '/dashboard/analytics',
							exact: true,
							component: DashboardAnalyticsView,
						},
						{
							path: '/dashboard/default',
							exact: true,
							component: DashboardDefaultView,
						},
						{
							path: '/invoices/:id',
							exact: true,
							component: lazy(() => import('views/InvoiceDetails')),
						},
						{
							path: '/kanban-board',
							exact: true,
							component: lazy(() => import('views/KanbanBoard')),
						},
						{
							path: '/mail',
							exact: true,
							component: lazy(() => import('views/Mail')),
						},
						{
							path: '/manage/customers',
							exact: true,
							component: lazy(() => import('views/CustomerManagementList')),
						},
						{
							path: '/manage/customers/:id',
							exact: true,
							component: lazy(() => import('views/CustomerManagementDetails')
							),
						},
						{
							path: '/manage/customers/:id/:tab',
							exact: true,
							component: lazy(() => import('views/CustomerManagementDetails')
							),
						},
						{
							path: '/manage/projects',
							exact: true,
							component: lazy(() => import('views/ProjectManagementList')),
						},
						{
							path: '/manage/orders',
							exact: true,
							component: lazy(() => import('views/OrderManagementList')),
						},
						{
							path: '/manage/orders/:id',
							exact: true,
							component: lazy(() => import('views/OrderManagementDetails')),
						},
						{
							path: '/overview',
							exact: true,
							component: OverviewView,
						},
						{
							path: '/presentation',
							exact: true,
							component: PresentationView,
						},
						{
							path: '/profile/:id',
							exact: true,
							component: lazy(() => import('views/Profile')),
						},
						{
							path: '/profile/:id/:tab',
							exact: true,
							component: lazy(() => import('views/Profile')),
						},
						{
							path: '/projects/create',
							exact: true,
							component: lazy(() => import('views/ProjectCreate')),
						},
						{
							path: '/projects/:id',
							exact: true,
							component: lazy(() => import('views/ProjectDetails')),
						},
						{
							path: '/projects/:id/:tab',
							exact: true,
							component: lazy(() => import('views/ProjectDetails')),
						},
						{
							path: '/projects',
							exact: true,
							component: lazy(() => import('views/ProjectList')),
						},
						{
							path: '/settings',
							exact: true,
							component: lazy(() => import('views/Settings')),
						},
						{
							path: '/settings/:tab',
							exact: true,
							component: lazy(() => import('views/Settings')),
						},
						{
							path: '/social-feed',
							exact: true,
							component: lazy(() => import('views/SocialFeed')),
						},
						{
							path: '/getting-started',
							exact: true,
							component: lazy(() => import('views/GettingStarted')),
						},
						{
							component: () => <Redirect to="/errors/error-404" />,
						},
					],
				},
			})
		}),
	},
];

export default routes;
